import * as types from "./mutation_types";

const URL_BACKEND = process.env.VUE_APP_URL_BACKEND;
import axios from "@/lib/axioxAppli";

export const reset = ({ commit }) => {
  commit(types.LIGNE_ROB_UPDATE_RESET);
};

export const updateLigneRob = ({ commit }, values) => {
  commit(types.LIGNE_ROB_UPDATE_SET_ERROR, "");
  commit(types.LIGNE_ROB_UPDATE_TOGGLE_LOADING);
  axios
    .put(URL_BACKEND + "api-rob/updateligne/" + values.id + "/", values.values)
    .then((response) => {
      commit(types.LIGNE_ROB_UPDATE_SET_UPDATED, true);
      commit(types.LIGNE_ROB_UPDATE_TOGGLE_LOADING);
      const index = values.list.findIndex((value) => value.id === values.id);
      if (index > -1) {
        values.list[index].facturette = response.data.facturette;
        values.list[index].annule = response.data.annule;
        values.list[index].statut = values.values.statut;
      }
    })
    .catch((e) => {
      commit(types.LIGNE_ROB_UPDATE_TOGGLE_LOADING);
      commit(types.LIGNE_ROB_UPDATE_SET_ERROR, e.message);
    });
};
